import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_APPLICATIONS } from '@/api/endpoints';
import { NON_ATTENDANCE_APPLICATIONS_QUERY_KEY } from '@/api/queryKeys';
import type { AbsenceApplication } from '@/components/AbsenceApplication/types';
import { unwrapAxiosResponse } from '@/utils/axios';

interface Options {
  enabled?: boolean;
}

export const useAbsenceApplications = ({ enabled = true }: Options = {}) =>
  useQuery<AbsenceApplication[]>({
    queryKey: NON_ATTENDANCE_APPLICATIONS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<AbsenceApplication[]>(API_NON_ATTENDANCE_APPLICATIONS)
        .then(unwrapAxiosResponse),
    enabled,
  });
